/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

// This file is auto-generated. Do not edit manually.
// Use: pnpm --filter components run generate-lottie-index

export enum LottieAnimationsEnum {
	FivePlanets_PurpleBlueGreen_6a = "FivePlanets_PurpleBlueGreen_6a",
	FivePlanets_PinkPeach_6b = "FivePlanets_PinkPeach_6b",
	FivePlanets_BlueGreen_6c = "FivePlanets_BlueGreen_6c",
	FivePlanets_OrangeYellow_6d = "FivePlanets_OrangeYellow_6d",
	StarClover_PurpleBlueGreen_7a = "StarClover_PurpleBlueGreen_7a",
	StarClover_PinkPeach_7b = "StarClover_PinkPeach_7b",
	StarClover_BlueGreen_7c = "StarClover_BlueGreen_7c",
	StarClover_OrangeYellow_7d = "StarClover_OrangeYellow_7d",
	SunMoon_PurpleBlueGreen_8a = "SunMoon_PurpleBlueGreen_8a",
	SunMoon_PinkPeach_8b = "SunMoon_PinkPeach_8b",
	SunMoon_BlueGreen_8c = "SunMoon_BlueGreen_8c",
	SunMoon_OrangeYellow_8d = "SunMoon_OrangeYellow_8d",
	MoonStar_PurpleBlueGreen_9a = "MoonStar_PurpleBlueGreen_9a",
	MoonStar_PinkPeach_9b = "MoonStar_PinkPeach_9b",
	MoonStar_BlueGreen_9c = "MoonStar_BlueGreen_9c",
	MoonStar_OrangeYellow_9d = "MoonStar_OrangeYellow_9d",
}
export type LottieAnimations = typeof LottieAnimationsEnum;

export const lottieAnimationsOptions = [
	"FivePlanets_PurpleBlueGreen_6a",
	"FivePlanets_PinkPeach_6b",
	"FivePlanets_BlueGreen_6c",
	"FivePlanets_OrangeYellow_6d",
	"StarClover_PurpleBlueGreen_7a",
	"StarClover_PinkPeach_7b",
	"StarClover_BlueGreen_7c",
	"StarClover_OrangeYellow_7d",
	"SunMoon_PurpleBlueGreen_8a",
	"SunMoon_PinkPeach_8b",
	"SunMoon_BlueGreen_8c",
	"SunMoon_OrangeYellow_8d",
	"MoonStar_PurpleBlueGreen_9a",
	"MoonStar_PinkPeach_9b",
	"MoonStar_BlueGreen_9c",
	"MoonStar_OrangeYellow_9d",
] as const;

export enum AnimationFilesEnum {
	v03_6a = "v03_6a",
	v03_6b = "v03_6b",
	v03_6c = "v03_6c",
	v03_6d = "v03_6d",
	v03_7a = "v03_7a",
	v03_7b = "v03_7b",
	v03_7c = "v03_7c",
	v03_7d = "v03_7d",
	v03_8a = "v03_8a",
	v03_8b = "v03_8b",
	v03_8c = "v03_8c",
	v03_8d = "v03_8d",
	v03_9a = "v03_9a",
	v03_9b = "v03_9b",
	v03_9c = "v03_9c",
	v03_9d = "v03_9d",
}
export type AnimationFiles = typeof AnimationFilesEnum;
